import { jsx as _jsx } from "react/jsx-runtime";
import { toast, Toaster as ReactToaster } from "react-hot-toast";
import classNames from "classnames";
import { UiCheckCircleIcon } from "@jti/brand-icons/ui-check-circle";
import { UiWarningSolidIcon } from "@jti/brand-icons/ui-warning-solid";
import styles from "./Toaster.module.scss";
export { toast };
export const Toaster = ({ duration = 5000 }) => {
    return (_jsx(ReactToaster, { toastOptions: {
            duration,
            error: {
                icon: _jsx(UiWarningSolidIcon, { className: styles.icon }),
                className: classNames(styles.toast, styles.error),
            },
            success: {
                icon: _jsx(UiCheckCircleIcon, { className: styles.icon }),
                className: classNames(styles.toast, styles.success),
            },
        } }));
};
//# sourceMappingURL=Toaster.js.map